import './App.css';
import Form from './components/Form/Form';

function App() {
  return (
    <div className="App">
      <Form/>
    </div>
  );
}

export default App;
